export const state = () => ({
  token: null,
  userInfo: null,
  cartModal: false,
  cart: [],
  cartInfo: {},
  accordionScript: false,
  fileDeviceType: {
    desktop: 1,
    mobile: 2
  },
  metalType: {
    yellowGold: {
      id: 6,
      sku: '14KY'
    },
    whiteGold: {
      sku: '14KW'
    },
    silver: {
      sku: 'SS'
    }
  },
  orderDiscountType: {
    percent: 1,
    fixed: 2
  },
  analyticsMarketingLoadTimeout: 4000,
  forcedSizeProductsSlug: ['SONLESS', 'SONLSNAKE', 'SONLWHEAT', 'SOBRCABO', 'SOBRDUO', 'SOBRMST'],
  holidayCodes: {
    holiday_sale: 'holiday_sale',
    holiday_wrap: 'holiday_wrap',
    valentines_day: 'valentines_day',
  },
  giftCardVendorModels: {
    physical: 'GIFTP',
    digital: 'GIFTD',
  },
  recentlyViewedPosts: [],
  recentlyViewedPostsLimit: 4,
  ringSizerVendorModel: 'RNGSZR',
  recentlyViewedProductsLimit: 10,
})

export const getters = {
  getForcedSizeProductsSlug (state) {
    return state.forcedSizeProductsSlug
  },
  getAuthorization (state) {
    return { headers: { Authorization: `Bearer ${state.token}` } }
  },
  getAccordionScript (state) {
    return state.accordionScript
  },
  isAuthorised (state) {
    return state.token
  },
  getBootstrap (state) {
    return state.localStorage.bootstrap
  },
  getHolidayCodes(state) {
    return state.holidayCodes;
  },
  isValentinesDay(state) {
    return state.localStorage.bootstrap?.data?.holidays?.find(item => item.code === state.holidayCodes.valentines_day)?.active_now;
  },
  isHolidayWrap(state) {
    return state.localStorage.bootstrap?.data?.holidays?.find(item => item.code === state.holidayCodes.holiday_wrap)?.active_now;
  },
  isHolidaySale(state) {
    return state.localStorage.bootstrap?.data?.holidays?.find(item => item.code === state.holidayCodes.holiday_sale)?.active_now;
  },
  getUserInfo (state) {
    return state.userInfo
  },
  getShowBottomSection (state) {
    return state.localStorage.showBottomSection
  },
  getCartId (state) {
    return state.localStorage.cart_unique_id
  },
  getCartItems (state) {
    return state.cart
  },
  getCartInfo (state) {
    return JSON.parse(JSON.stringify(state.cartInfo))
  },
  getCartModal (state) {
    return state.cartModal
  },
  getFileDeviceType(state) {
    return state.fileDeviceType
  },
  getMetalType(state) {
    return state.metalType
  },
  getOrderDiscountType(state) {
    return state.orderDiscountType
  },
  getAnalyticsMarketingLoadTimeout(state) {
    return state.analyticsMarketingLoadTimeout
  },
  getRecentlyViewedProducts(state) {
    return state.localStorage.recentlyViewedProducts
  },
  getRecentlyViewedPosts(state) {
    return state.recentlyViewedPosts || []
  },
  getRecentlyViewedPostsId(state) {
    return state.localStorage.recentlyViewedPostsId || []
  },
  getGiftCardVendorModels(state) {
    return state.giftCardVendorModels;
  },
  getRingSizerVendorModel(state) {
    return state.ringSizerVendorModel;
  },
}

export const mutations = {
  setLocalVar(state, payload) {
    state.localStorage[payload.var] = payload.val
  },
  setStoreVar(state, payload) {
    state[payload.var] = payload.val
  },
  setUserInfo (state, payload) {
    state.userInfo = payload
  },
  setBootstrap (state, payload) {
    state.localStorage.bootstrap = payload
  }
}

export const actions = {
  setRecentlyViewedProducts({ state, getters, commit }, payload) {
    const productList = JSON.parse(JSON.stringify(getters.getRecentlyViewedProducts));
    const sameProductIndex = productList.findIndex(item => item.id === payload.id);
    if(sameProductIndex > -1) {
      productList.splice(sameProductIndex, 1);
    }
    productList.unshift(payload);
    if(productList.length > state.recentlyViewedProductsLimit) {
      productList.length = state.recentlyViewedProductsLimit;
    }
    commit('setLocalVar', {var: 'recentlyViewedProducts', val: productList});
  },
  setRecentlyViewedPosts({ state, getters, commit }, payload) {
    const postList = JSON.parse(JSON.stringify(getters.getRecentlyViewedPostsId));
    const samePostIndex = postList.findIndex(item => item === payload);
    if(samePostIndex > -1) {
      postList.splice(samePostIndex, 1);
    }
    postList.unshift(payload);
    if(postList.length > state.recentlyViewedPostsLimit) {
      postList.length = state.recentlyViewedPostsLimit;
    }
    commit('setLocalVar', {var: 'recentlyViewedPostsId', val: postList});
  },
  async fetchRecentlyViewedPosts({ state, getters, commit }) {
    if (!getters.getRecentlyViewedPostsId.length) {
      return;
    }
    try {
      const params = {
        count: state.recentlyViewedPostsLimit,
        ids: getters.getRecentlyViewedPostsId
      };
      const { data } = await this.$api.blog.getPosts(params);
      const postList = [];
      getters.getRecentlyViewedPostsId.forEach(item => {
        const post = data.data?.find(findItem => findItem.id === item);
        if (post) {
          postList.push(post);
        }
      })
      commit('setStoreVar', {var: 'recentlyViewedPosts', val: postList});
    } catch (err) {
      console.log("err - ", err?.response?.data?.errors);
    }
  },
  removeUserInfo ({ commit }) {
    commit('setUserInfo', null)
    this.$cookies.remove('userInfo', { path: '/' })
  },
  setUserInfo ({ commit }, payload) {
    commit('setUserInfo', payload)
    this.$cookies.set('userInfo', payload, { maxAge: 86400, path: '/' })
  },
  nuxtServerInit ({ commit, dispatch }, context) {
    if (context.app.$cookies.get('userInfo')) {
      commit('setUserInfo', context.app.$cookies.get('userInfo'))
    }
  },
  async getCart({ commit, dispatch, state, getters }) {
    const params = {};
    if (getters.getCartId && !getters.getUserInfo) {
      params.cart_unique_id = getters.getCartId
    }

    return this.$axios.get('/carts', {headers: {'Authorization': getters.getUserInfo ? `Bearer ${getters.getUserInfo.access_token.token}` : null}, params})
      .then(res => {
        const data = res.data.data;
        data.cart?.items?.forEach(item => {
          if (item.options.engraving_upload) {
            item.options.engraving_upload = JSON.parse(item.options.engraving_upload);
          }
        });

        commit('setLocalVar', {var: 'cart_unique_id', val: data.cart.unique_id});
        commit('setStoreVar', {var: 'cart', val: data.cart.items});
        commit('setStoreVar', {var: 'cartInfo', val: data.cart});
      })
      .catch(err => {
        // commit('setLocalVar', {var: 'cart_unique_id', val: null});
      })
  },
  resetCart({ commit }) {
    commit('setLocalVar', {var: 'cart_unique_id', val: null});
    commit('setStoreVar', {var: 'cart', val: []});
    commit('setStoreVar', {var: 'cartInfo', val: {}});
  }
}
